<app-header></app-header>
<div class="mainSection">
	<toaster-container [toasterconfig]="config"></toaster-container>
	<router-outlet></router-outlet>
</div>
<app-footer></app-footer>
